import { type CouponItemV1, setCoupons as setCouponsV1 } from '@castlery/modules-order-domain';
import { setCouponsV2, type CouponItemV2 } from '@castlery/modules-promotion-domain';
import { enabledNewPromotion } from '@castlery/config';
import { applyCouponCommand, fetchCouponsCommand } from '@castlery/shared-services';
import dayjs from 'dayjs';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExtraArgument } from '@castlery/shared-redux-extra';
import { RootState } from '@castlery/shared-redux-store';

export const getAutoApplyCouponV1 = (coupons: CouponItemV1[]) => {
  if (Array.isArray(coupons) && coupons.length === 1) {
    const coupon = coupons[0];
    const { available, expired_at } = coupon;
    const eligible =
      typeof available === 'boolean' ? available : expired_at ? dayjs().isBefore(dayjs(expired_at)) : false;
    if (eligible) {
      return coupon.code;
    }
    return '';
  }
  return '';
};

export const refreshAndAutoApplyCoupon = createAsyncThunk(
  'order/refreshAndApplyCoupon',
  async (_, { dispatch, extra, getState, rejectWithValue }) => {
    if (enabledNewPromotion) {
      await dispatch(setCouponsV2([]));
    } else {
      await dispatch(setCouponsV1([]));
    }
    const { persistenceHandles } = extra as ExtraArgument;
    const orderNumber = persistenceHandles.orderNumber.getItem() || undefined;
    if (!orderNumber) {
      return rejectWithValue('refreshAndAutoApplyCoupon>>:orderNumber is not found');
    }
    const res = await dispatch(fetchCouponsCommand());

    if ('error' in res) {
      return rejectWithValue(res.error);
    }
    if (res.payload && res.payload.length > 0) {
      if (enabledNewPromotion) {
        await dispatch(setCouponsV2(res.payload as unknown as CouponItemV2[]));
      } else {
        await dispatch(setCouponsV1(res.payload as unknown as CouponItemV1[]));
      }
      const rootState = getState() as RootState;
      const items = rootState.order.order?.line_items || [];
      if (!items.length) {
        return rejectWithValue('refreshAndAutoApplyCoupon>>:lineItems is not found');
      }
      if (!enabledNewPromotion) {
        const coupon = getAutoApplyCouponV1(res.payload as unknown as CouponItemV1[]);
        if (coupon) {
          const markedCouponSymbol = persistenceHandles.autoAppliedCoupon.getItem() || '';
          const currentCouponSymbol = autoCouponMarked(orderNumber, coupon);
          if (markedCouponSymbol !== currentCouponSymbol) {
            await dispatch(applyCouponCommand({ couponCode: coupon }));
          }
        }
      }
      return res.payload;
    }
    return rejectWithValue('coupons is not found');
  }
);

export const autoCouponMarked = (orderNumber: string, couponCode: string) => {
  return `${orderNumber}_${couponCode}`;
};
